import React from 'react';
import { ExternalLink } from 'lucide-react';

interface LinkPreviewProps {
  url: string;
}

const LinkPreview: React.FC<LinkPreviewProps> = ({ url }) => {
  // Function to extract Facebook username/ID from URL
  const extractFacebookIdentifier = (url: string) => {
    const profileMatch = url.match(/facebook\.com\/(?:profile\.php\?id=(\d+)|([^/?]+))/);
    return profileMatch ? profileMatch[1] || profileMatch[2] : null;
  };

  // Function to create embed URL
  const getEmbedUrl = (url: string) => {
    const identifier = extractFacebookIdentifier(url);
    if (!identifier) return null;
    
    // For profile pages, we'll show a different preview
    if (url.includes('profile.php?id=')) {
      return `https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D${identifier}&tabs&width=500&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=false&appId`;
    }
    
    return `https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F${identifier}&tabs&width=500&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=false&appId`;
  };

  const embedUrl = getEmbedUrl(url);

  if (!embedUrl) {
    return (
      <a 
        href={url} 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-blue-500 hover:text-blue-600 flex items-center gap-2"
      >
        <ExternalLink size={16} />
        {url}
      </a>
    );
  }

  return (
    <div className="my-2 rounded-lg border border-gray-200 overflow-hidden bg-white">
      <iframe
        src={embedUrl}
        width="500"
        height="130"
        style={{ border: 'none', overflow: 'hidden' }}
        scrolling="no"
        frameBorder="0"
        allowFullScreen={true}
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        className="w-full"
      ></iframe>
    </div>
  );
};

export default LinkPreview;
